import * as Dialog from '@radix-ui/react-dialog';
import { forwardRef } from 'react';

export const ModalDialogTrigger = forwardRef<
  HTMLButtonElement,
  Dialog.DialogTriggerProps
>(({ children, ...props }, ref) => {
  return (
    <Dialog.Trigger ref={ref} {...props} asChild>
      {children}
    </Dialog.Trigger>
  );
});

ModalDialogTrigger.displayName = 'ModalDialog.Trigger';
